export default {
  getDrawer: state => state.drawer,
  getTableSettings: state => id => state.tableSettings.find(item => item.id === id),
}
